import { render, staticRenderFns } from "./change-email-address.vue?vue&type=template&id=1fe8db72&"
import script from "./change-email-address.vue?vue&type=script&lang=js&"
export * from "./change-email-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports